module.exports = __webpack_public_path__ + "static/media/8a68cb77.jpg";